module.exports = __webpack_public_path__ + "static/media/waves.7ef645b6.png";